import { useParams } from "react-router";
import { ProfileEdit } from "./ProfileEdit";

export function ProfileEditPage() {
  const { id } = useParams();

  return <ProfileEdit id={id} />;
}
